import { useState } from 'react';

import TableIcon from '~shared/assets/icons/table.svg?react';

import { Button } from '@breezeventures/ui-kit/button';
import { CheckboxGroup } from '@breezeventures/ui-kit/checkbox-group';
import { Modal } from '@breezeventures/ui-kit/modal';
import { Typography } from '@breezeventures/ui-kit/typography';

type ColumnOption = {
  id: string;
  label: string;
};

type Props = {
  options: ColumnOption[];
  value: string[];
  onApply: (visibleIds: string[]) => void;
};

export function TableColumnsButton({ options, value, onApply }: Props) {
  const [opened, setOpened] = useState(false);
  const [selected, setSelected] = useState<string[]>(value);

  const open = () => {
    setSelected(value);
    setOpened(true);
  };

  const apply = () => {
    onApply(selected);
    setOpened(false);
  };

  const isOnlySelected = (id: string) =>
    selected.length === 1 && selected.includes(id);

  return (
    <>
      <Button type="button" size="s" variant="secondary" onClick={open}>
        <TableIcon className="size-4" />
        Table
      </Button>

      <Modal opened={opened} onClose={() => setOpened(false)}>
        <Typography.Text
          size="m"
          weight="medium"
          tag="p"
          className="mb-4 text-center"
        >
          Displayed columns
        </Typography.Text>

        <CheckboxGroup.Root
          value={selected}
          onChange={setSelected}
          className={`
            flex flex-col divide-y divide-separator overflow-hidden rounded-2xl
            border border-separator
          `}
        >
          {options.map((option) => (
            <CheckboxGroup.Item
              key={option.id}
              value={option.id}
              reversed
              disabled={isOnlySelected(option.id)}
              className="p-4"
            >
              {option.label}
            </CheckboxGroup.Item>
          ))}
        </CheckboxGroup.Root>

        <div className="mt-6">
          <Modal.FooterActions>
            <Button variant="primary" size="l" width="full" onClick={apply}>
              Apply
            </Button>
          </Modal.FooterActions>
        </div>
      </Modal>
    </>
  );
}
